// Directorio General del Instituto Tlaxcalteca de Elecciones
// Datos sincronizados con el panel SIGEC

export const directorioData = [
  {
    cargo: "Consejero Presidente",
    nombre: "Lic. Emmanuel Ávila González",
    unidad: "Presidencia",
    extension: "200",
    correo: "presidencia@itetlax.org.mx"
  },
  {
    cargo: "Consejera Electoral",
    nombre: "Lic. Janet Cervantes Ahuatzi",
    unidad: "Consejería",
    extension: "208",
    correo: "janet.cervantes@itetlax.org.mx"
  },
  {
    cargo: "Consejera Electoral",
    nombre: "Lic. Yedith Martínez Pinillo",
    unidad: "Consejería",
    extension: "303",
    correo: "yedith.martinez@itetlax.org.mx"
  },
  {
    cargo: "Consejero Electoral",
    nombre: "Lic. Hermenegildo Neria Carreño",
    unidad: "Consejería",
    extension: "301",
    correo: "hemenegildo.neria@itetlax.org.mx"
  },
  {
    cargo: "Consejera Electoral",
    nombre: "Dra. Anakaren Monserrat Rojas Cuahutle",
    unidad: "Consejería",
    extension: "306",
    correo: "anakaren.monserrat@itetlax.org.mx"
  },
  {
    cargo: "Consejera Electoral",
    nombre: "Mtra. Brenda Fernanda Barron Rugerio",
    unidad: "Consejería",
    extension: "307",
    correo: "fernanda.barron@itetlax.org.mx"
  },
  {
    cargo: "Secretaria Ejecutiva",
    nombre: "Mtra. Elizabeth Vázquez Alonso",
    unidad: "Secretaría Ejecutiva",
    extension: "103",
    correo: "secretaria@itetlax.org.mx"
  },
  {
    cargo: "Titular",
    nombre: "Lic. Susana Manzano Sánchez",
    unidad: "Órgano Interno de Control",
    extension: "312",
    correo: "contraloria@itetlax.org.mx"
  },
  {
    cargo: "Directora",
    nombre: "C.P. María Paula Escobar Aguirre",
    unidad: "Dirección de Prerrogativas, Administración y Fiscalización",
    extension: "109",
    correo: "prerrogativas@itetlax.org.mx"
  },
  {
    cargo: "Directora",
    nombre: "Lic. Nancy García Ramírez",
    unidad: "Dirección de Organización Electoral, Capacitación y Educación Cívica",
    extension: "105",
    correo: "organizacionelectoral@itetlax.org.mx"
  },
  {
    cargo: "Director",
    nombre: "Lic. Rafael Pérez Salazar",
    unidad: "Dirección de Asuntos Jurídicos",
    extension: "202",
    correo: "juridico@itetlax.org.mx"
  },
  {
    cargo: "Encargado",
    nombre: "Ing. Miguel Ángel Muñoz Pozos",
    unidad: "Área Técnica de Informática",
    extension: "203",
    correo: "informatica@itetlax.org.mx"
  },
  {
    cargo: "Titular",
    nombre: "Mtra. Elizabeth González Serrano",
    unidad: "Área Técnica de Comunicación Social",
    extension: "211",
    correo: "comunicacion@itetlax.org.mx"
  },
  {
    cargo: "Titular",
    nombre: "Mtra. Ana Lilia Arévalo Herrerra",
    unidad: "Área Técnica de Consulta Ciudadana",
    extension: "406",
    correo: "consulta.ciudadana@itetlax.org.mx"
  },
  {
    cargo: "Encargada",
    nombre: "Mtra. Diana Elvira Meneses Saldaña",
    unidad: "Área Técnica de Transparencia y Acceso a la Información",
    extension: "111",
    correo: "transparencia@itetlax.org.mx"
  },
  {
    cargo: "Encargado",
    nombre: "Lic. Abraham Pérez Hernández",
    unidad: "Unidad Técnica de lo Contencioso Electoral",
    extension: "104",
    correo: "utce@itetlax.org.mx"
  }
];
